module.exports = __webpack_public_path__ + "static/smi2-6463283a15e4ad97785801d69ebeb8fa.png";